import React from 'react';

function ScratchToImplementation({ setView }) {
  const handleDiscussClick = (e) => {
    e.preventDefault();
    const contactForm = document.querySelector('.contact-section') || document.getElementById('contact-form');
    if (contactForm) {
      contactForm.scrollIntoView({ behavior: 'smooth' });
    } else if (setView) {
      window.history.pushState({}, '', '/contact/');
      setView('contact');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="scratch-implementation-section">
      <div className="container scratch-implementation-container">
        {/* Left Column: Text Content & List */}
        <div className="scratch-implementation-left">
          <h2 className="scratch-implementation-title">
            We Handle Everything, From Scratch To Implementation!
          </h2>
          
          <p className="scratch-implementation-desc">
            Experts Communication is here to grow your business in every way possible. Our BPO company knows how to use expertise in the most effective way to bring the best outcomes. Moreover, our IT company gives you the freedom to work hassle-free by providing reliable software solutions and strong security systems—so you can focus on what matters most.
          </p>

          <ul className="scratch-implementation-list">
            <li>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="list-arrow-icon">
                <polyline points="9 18 15 12 9 6" />
              </svg>
              We are Leading in Call Center Service
            </li>
            <li>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="list-arrow-icon">
                <polyline points="9 18 15 12 9 6" />
              </svg>
              Guidance From Our Expert Staff
            </li>
            <li>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="list-arrow-icon">
                <polyline points="9 18 15 12 9 6" />
              </svg>
              Solutions For Small & Large Business
            </li>
            <li>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="list-arrow-icon">
                <polyline points="9 18 15 12 9 6" />
              </svg>
              Learn From Customer Feedback
            </li>
          </ul>

          <button className="btn-schedule btn-discuss-needs" onClick={handleDiscussClick}>
            Let's Discuss Your Needs
          </button>
        </div>

        {/* Right Column: Image */}
        <div className="scratch-implementation-right">
          <img 
            src="/assets/images/scratch_to_implementation.png" 
            alt="Scratch to Implementation" 
            className="scratch-implementation-img"
          />
        </div>
      </div>
    </section>
  );
}

export default ScratchToImplementation;
